import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { LetterDocumentService } from '../../../Model/LetterDocument/letter-document.service';
import { LetterDocumentTypeFormComponent } from '../letter-document-type-form/letter-document-type-form.component';

@Component({
  selector: 'app-letter-document-type',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './letter-document-type.component.html',
  styleUrl: './letter-document-type.component.scss'
})
export class LetterDocumentTypeComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  
  dtoptions: DataTables.Settings = {};
  constructor(
    private modalService: NgbModal,
    protected common: CommonService,
    private letterDocument: LetterDocumentService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESSLetterDocumentTypeMasterSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  addLetterDocument(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(LetterDocumentTypeFormComponent);
      modalRef.componentInstance.ID = ID;
      modalRef.result.then(
        (result: any) => {
          if (result) {
            this.ESSLetterDocumentTypeMasterSelect();
          }
        },
        () => { }
      );
    }
  }

  ESSLetterDocumentTypeMasterSelect() {
    this.isDisabled = true;
    this.letterDocument.ESSLetterDocumentTypeMasterSelect({ ESS_LetterDocumentTypeMasterID: 0, SelectType: 1 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = Object.values([]);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
